import Grid from "@mui/material/Grid";
import React from "react";
import LabCard from "./LabCard";
import { LabDto } from "../../../../../customer-experience/src/lib/ShiOneClient";
import { useQueryClient } from "@tanstack/react-query";
import { IncludeExcludeFilterCategory } from "../../../components/include-exclude-filter/reducers/includeExcludeFilterReducer";
import { CACHE_KEY_LABS, CACHE_KEY_LABS_PICKLIST } from "../constants";
import { LabsApiContext } from "../LabsApiContext";

export const labPracticePalette = [
  "#692CB7",
  "#3A56D2",
  "#17BFD6",
  "#15AAA2",
  "#5FA58C",
  "#48E4A3",
  "#D0CF00",
  "#F8C128",
  "#E48543",
  "#BE4939",
  "#E48B94",
  "#BA6AAD",
];

export type LabPracticeTitleData = {
  color: string;
  title: string;
};

export const LabCards = ({
  labs,
  handleOpenLabDetails,
  handleSelectLab,
  isFilteredResult,
}: {
  labs: LabDto[];
  handleOpenLabDetails: () => void;
  handleSelectLab: (lab: LabDto) => void;
  isFilteredResult: boolean;
}) => {
  const queryClient = useQueryClient();
  const labsApi = React.useContext(LabsApiContext);
  const useDefinitionsPayload = labsApi?.useDefinitionsPayload ?? false;

  const filterOptions = queryClient.getQueryData<
    IncludeExcludeFilterCategory[]
  >([
    CACHE_KEY_LABS,
    CACHE_KEY_LABS_PICKLIST,
    useDefinitionsPayload ? "definitions" : "legacy",
  ]);

  const practiceCategory = filterOptions?.find((c) => c.id === "practice");
  const uniqueLabPractices = practiceCategory?.options
    ? practiceCategory.options.map((o) => o.item)
    : [];

  let labPracticeTitleData: LabPracticeTitleData[] = [];
  if (uniqueLabPractices.length > 0) {
    const practiceTitleData: LabPracticeTitleData[] = [];
    uniqueLabPractices.forEach((practice, index) => {
      practiceTitleData[index] = {
        color: labPracticePalette[index],
        title: practice,
      };
    });
    labPracticeTitleData = practiceTitleData;
  }

  if (labs.length === 0) {
    return <></>;
  }

  return (
    <Grid container spacing={3}>
      {labs.map((lab) => {
        return (
          <Grid container key={lab.id} size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
            <LabCard
              lab={lab}
              isFilteredResult={isFilteredResult}
              handleOpenLabDetails={handleOpenLabDetails}
              labPracticeTitleData={labPracticeTitleData}
              handleSelectLab={handleSelectLab}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
